import dayjs from "dayjs";
import { dateFormate } from "@constants/index"; 

export const calculateMaxDates = (childData:any) => {
    const currentDate = dayjs().format(dateFormate.yyyy_mm_dd);
    const dob = dayjs(childData?.dob);

    const opvMaxDate = dob.add(15, "day").format(dateFormate.yyyy_mm_dd);
    const bcgMaxDate = dob.add(365, "day").format(dateFormate.yyyy_mm_dd);
    const vitMaxDate = dob.add(1, "day").format(dateFormate.yyyy_mm_dd);
    const hepMaxDate = dob.add(1, "day").format(dateFormate.yyyy_mm_dd);

    return {
        opvMaxDate: dayjs(opvMaxDate).isAfter(currentDate) ? currentDate : opvMaxDate,
        bcgMaxDate: dayjs(bcgMaxDate).isAfter(currentDate) ? currentDate : bcgMaxDate,
        vitMaxDate: dayjs(vitMaxDate).isAfter(currentDate) ? currentDate : vitMaxDate,
        hepMaxDate: dayjs(hepMaxDate).isAfter(currentDate) ? currentDate : hepMaxDate,
    };
};
